import React from "react";
import { StationsStore, stationsStore } from "@app/Stores/StationsStore";

export class StationsModuleStore {
    public stationStore: StationsStore;

    constructor() {
        this.stationStore = stationsStore;
    }
}

export const StationsModuleContext = React.createContext<StationsModuleStore | null>(null);

export const StationsModuleProvider = ({ children }: React.PropsWithChildren) => {
    const store = React.useMemo(() => new StationsModuleStore(), []);

    return (
        <StationsModuleContext.Provider value={store}>
            {children}
        </StationsModuleContext.Provider>
    );
};